import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81f14ec6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "閉じる", -1))
const _hoisted_2 = [
  _hoisted_1
]


export default /*#__PURE__*/_defineComponent({
  __name: 'MailSecurityPopupView',
  props: {
  isShowCloseBtnPopup: {
    type: Boolean,
    default: true
  },
  isShowSecondClosePopup: {
    type: Boolean,
    default: false
  },
  modalSize: {
    type: String as () => '' | 'large',
    default: ''
  }
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props







return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-recommend-form__modal is-active", { 'js-modal-container': props.isShowCloseBtnPopup }]),
    id: "complete"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["p-recommend-form__modal-card -is-complete", __props.modalSize])
    }, [
      (props.isShowCloseBtnPopup)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: "",
            class: "p-recommend-form__modal-help-close js-modal-close-trigger",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('close')), ["prevent"]))
          }, "閉じる"))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default"),
      (props.isShowSecondClosePopup)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "p-recommend-form__modal-help-close-2 --type-1 js-modal-close-trigger",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
          }, _hoisted_2))
        : _createCommentVNode("", true)
    ], 2),
    (props.isShowCloseBtnPopup)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "p-recommend-form__modal-close-area js-modal-close-trigger",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})